import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { EquipmentConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { EquipmentService } from './api/equipment.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class EquipmentApiModule {
    public static forRoot(configurationFactory: () => EquipmentConfiguration): ModuleWithProviders<EquipmentApiModule> {
        return {
            ngModule: EquipmentApiModule,
            providers: [ { provide: EquipmentConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: EquipmentApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('EquipmentApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
